import { setShowRetentionPaymentModal } from '../../../State/showRetentionPaymentModal'
import { setSelectedRetentionPaymentId } from '../../../State/selectedRetentionPaymentId'

export default (id) => async (dispatch) => {

  dispatch(setSelectedRetentionPaymentId(id))
  dispatch(setShowRetentionPaymentModal(true))

}